/* eslint-disable no-continue */
import { ContentType, PageType, ThemeType, Translations } from 'types/publishedAssets';
import { TranslatableField } from 'types/supportedLanguages';

export const determinePageHeadline = (
  page: PageType,
  translate: (translations: Translations, key: string) => string,
) => {
  // prioritize hero title first
  for (let sectionIt = 0; sectionIt < page?.sections?.length; sectionIt++) {
    const section = page?.sections?.[sectionIt];
    for (let entityIt = 0; entityIt < section?.section_entities?.length; entityIt++) {
      const entity = section?.section_entities?.[entityIt];
      if (!entity) continue;
      if (entity.content_type !== 'hero') continue;
      const heroTitle = translate(entity.translations, 'heading');
      if (heroTitle) return heroTitle;
    }
  }
  // fallback to page title
  return translate(page.translations || {}, 'title');
};

export const determinePageTitle = (page: PageType, translate: (translations: Translations, key: string) => string) =>
  translate(page.translations || {}, 'title');

export const determinePageDescription = (
  page: PageType,
  translate: (translations: Translations, key: string) => string,
) => {
  // prioritize hero description first
  for (let sectionIt = 0; sectionIt < page?.sections?.length; sectionIt++) {
    const section = page?.sections?.[sectionIt];
    for (let entityIt = 0; entityIt < section?.section_entities?.length; entityIt++) {
      const entity = section?.section_entities?.[entityIt];
      if (!entity) continue;
      if (entity.content_type !== 'hero') continue;
      const heroDescription = translate(entity.translations, 'description');
      if (heroDescription) return heroDescription;
    }
  }
  // fallback to page description (tbd currently this is always empty)
  return translate(page.translations || {}, 'description');
};

export const determineLogoImage = (
  theme: ThemeType,
  translateField: (field: TranslatableField, fallbackOverride?: string) => string,
) => theme?.brandLogoUrl || translateField(theme?.logo, theme?.defaultLanguage);

export const determineHeroImage = (
  page: PageType,
  getMediaItem: (content: ContentType, index: number) => { url: string; alt_text?: string; caption?: string } | null,
) => {
  // prioritize hero image first
  for (let sectionIt = 0; sectionIt < page?.sections?.length; sectionIt++) {
    const section = page?.sections?.[sectionIt];
    for (let entityIt = 0; entityIt < section?.section_entities?.length; entityIt++) {
      const entity = section?.section_entities?.[entityIt];
      if (!entity) continue;
      if (entity.content_type !== 'hero') continue;
      const heroImage = getMediaItem(entity, 0)?.url;
      if (heroImage) return heroImage;
    }
  }
  return null;
};
